import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	width: 100%;
	height: auto;
`;
export const Label = styled.label`
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 120%;
	letter-spacing: -0.6px;
`;
